import script from "./TopRightActions.vue?vue&type=script&setup=true&lang=js"
export * from "./TopRightActions.vue?vue&type=script&setup=true&lang=js"

import "./TopRightActions.vue?vue&type=style&index=0&id=eddcc218&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eddcc218"]])

export default __exports__